/**
 * PortfolioBestaende (R2-Punkt 1) — Portfolio-Gesamtübersicht der Bankbestände
 * je Gesellschaft: Bank (frei) / Kaution (gebunden) / Capex (gebunden), mit
 * Stichtag je Gesellschaft (aus bank_bestaende, D-050).
 *
 * HARTE null-Regel (SCHEMA_MAPPING §5): bank_bestaende null (keine 2026-SuSa)
 * ODER Einzelwert null → "—", NIE 0. Keine Ampel (reine Bestandszahlen).
 */
import type { MemberKpi } from '../types/snapshot';
import { DASH, formatEur } from '../lib/format';

export interface PortfolioBestaendeProps {
  members: MemberKpi[];
}

export function PortfolioBestaende({ members }: PortfolioBestaendeProps) {
  return (
    <section aria-label="Portfolio-Bestände (Bank / Kaution / Capex)">
      <h2 className="mb-1 text-lg font-semibold text-text">Bestände (Bank / Kaution / Capex)</h2>
      <p className="mb-3 text-xs text-text-muted">
        Bank = frei verfügbar · Kaution und Capex sind zweckgebunden. Stichtag je
        Gesellschaft.
      </p>
      <div className="overflow-x-auto rounded-lg border border-border bg-surface">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border text-left text-text-muted">
              <th scope="col" className="px-4 py-2 font-medium">Gesellschaft</th>
              <th scope="col" className="px-4 py-2 text-right font-medium">
                Bank <span className="font-normal text-ampel-green">· frei</span>
              </th>
              <th scope="col" className="px-4 py-2 text-right font-medium">
                Kaution <span className="font-normal text-text-muted">· gebunden</span>
              </th>
              <th scope="col" className="px-4 py-2 text-right font-medium">
                Capex <span className="font-normal text-text-muted">· gebunden</span>
              </th>
              <th scope="col" className="px-4 py-2 text-right font-medium">Stichtag</th>
            </tr>
          </thead>
          <tbody>
            {members.map((m) => {
              const b = m.bank_bestaende;
              return (
                <tr key={m.short_name} className="border-b border-border last:border-0">
                  <th scope="row" className="px-4 py-3 text-left font-medium text-text">
                    {m.short_name}
                  </th>
                  <td className="px-4 py-3 text-right tabular-nums">{formatEur(b?.bank)}</td>
                  <td className="px-4 py-3 text-right tabular-nums">{formatEur(b?.kaution)}</td>
                  <td className="px-4 py-3 text-right tabular-nums">{formatEur(b?.capex)}</td>
                  <td className="px-4 py-3 text-right tabular-nums text-text-muted">
                    {b?.stichtag ?? DASH}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}
